import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Row, Col, Modal, Button } from "react-bootstrap";
import { QUESTIONLIST, CREATENEW, CANCEL, DISABLE, ENABLE } from "../../../../shared/constants/Constants";
import ListView from "../../../../shared/components/listview/ListView";
import Breadcrumbs from "../../../../shared/components/Breadcrumbs";
import { loadQuestionTemplateDataRequest } from "../redux/Actions";
import DefaultButton from "../../../../shared/components/DefaultButton";
import Permissions from "../../../../shared/components/Permissions";
import Modalpopup from "../../../../shared/components/Modalpopup";

const QuestionList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { questionlist } = useSelector((state) => state.question);
  const [showQuestionsModal, setShowQuestionsModal] = useState(false);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  let [selectedRow, setSelectedRow] = useState({});
  let [clickStatusFunc, setClickStatusFunc] = useState(null);
  let [showStatusModal, setShowStatusModal] = useState(false);
  
  const emp_no = JSON.parse(localStorage.getItem("emp_no"));
  const module_name = "Question Template";
  const permission = Permissions(emp_no, module_name);

  useEffect(() => {
    dispatch(loadQuestionTemplateDataRequest());
  }, [dispatch]);

  //  Questions popup
  const handleQuestionsClick = (row) => {
    setSelectedQuestions(Array.isArray(row.questions) ? row.questions : []);
    setShowQuestionsModal(true);
  };

  //  Edit navigation
  const handleEdit = (row) => {
    navigate(`/questionform/${row.id}`);
  };

  //status 
  // useEffect(() => {
  //     setClickStatusFunc(
  //       () => (row) => {
  //         setSelectedRow(row);
  //         setShowStatusModal(true);  
  //       })
  // }, [])

  // const handleStatus = async (row) => {
  //   await dispatch(loadCategoryDeleteDataRequest(row.id));
  //   setShowStatusModal(false);
  //   setReload(prev => !prev);
  // };

  // transfered data
  const transformedRows = (questionlist?.data || []).map((item) => {
    const description = item.template_description || "";
    const words = description.split(/\s+/);
    const shortDescription =
      words.length > 100
        ? words.slice(0, 100).join(" ") + "..."
        : description;

    return {
      ...item,      
      short_description: shortDescription,      
      question_label:
        item.question_count === 1
          ? "1 Question"
          : `${item.question_count} Questions`,
      
      questions: item.questions || [],
    };
  });


  const columnDefs = [
    {
      display_name: "ID",
      field: "id",
      hide: true,
    },
    {
      display_name: "Actions",
      field: "actions",
      pinned: "left",
      width: 100,
    },
    {
      display_name: "Template Name",
      field: "template_name",
      width: 250,
      pinned: "left",
    },
    {
      display_name: "Description",
      field: "short_description",
      width: 300,
    },
    {
      display_name: "Questions",
      field: "question_label",
      type: "customLink",
      functionTo: handleQuestionsClick,
      width: 130,
    },
  ];

  return (
    <>
      <Row className="detailsPageHeader">
        <Col>
          <Breadcrumbs
            children={[{ href: "/questionlist", label: QUESTIONLIST }]}
          />
        </Col>
        <Col xs="auto">
          {permission.create_permission && (
            <DefaultButton
              buttonClass="default-btn-color"
              buttonTitle={CREATENEW}
              actionBlock={() => navigate("/questionform/add")}
            />
          )}
        </Col>
      </Row>

      <ListView
        columnNames={columnDefs}
        rowData={transformedRows}
        clickEdit={handleEdit}
       // clickStatus={clickStatusFunc}
      />
      {/*  status Modal */}
      {/* <Modalpopup height="80vh" size="lg" show={showStatusModal} handleClose={() => setShowStatusModal(false)} actionTitle="Category Configuration">
      <p>
        {selectedRow?.status
          ? <>Do you want to Disable <strong>{selectedRow?.configname}</strong></>
          : <>Do you want to Enable <strong>{selectedRow?.configname}</strong></>
        }
      </p>

      <div className="col-md-12">
        <DefaultButton
          buttonClass="btn btn-secondary me-2"
          buttonTitle={CANCEL}
          actionBlock={() => setShowStatusModal(false)}
        />
        <DefaultButton
          buttonClass={selectedRow?.status ? "btn btn-danger" : "btn btn-success"}
          buttonTitle={selectedRow?.status ? DISABLE : ENABLE}
          actionBlock={() => handleStatus(selectedRow)}
        />
      </div>
    </Modalpopup> */}

      {/*  Questions Modal */}
      <Modal
        show={showQuestionsModal}
        onHide={() => setShowQuestionsModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Questions</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedQuestions.length > 0 ? (
            selectedQuestions.map((q, index) => (
              <div
                key={q.id || index}
                className="d-flex align-items-center border rounded p-2 mb-2 bg-light"
              >
                <div className="d-flex align-items-center gap-2">
                  <strong>
                    {index + 1}. {q.questionText}
                  </strong>

                  <span className="badge bg-primary bg-opacity-25 text-primary">
                    {q.answerType}
                  </span>

                  {q.isRequired && (
                    <span className="badge bg-danger bg-opacity-25 text-danger">
                      Required
                    </span>
                  )}
                </div>
              </div>
            ))
          ) : (
            <p>No questions found.</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowQuestionsModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default QuestionList;
